/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
} from './PaymentState';

/**
 * 
 * @export
 * @interface SplitByAmountSuccessResponse
 */
export interface SplitByAmountSuccessResponse {
    /**
     * 
     * @type {PaymentState}
     * @memberof SplitByAmountSuccessResponse
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof SplitByAmountSuccessResponse
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof SplitByAmountSuccessResponse
     */
    bookingReference: string;
    /**
     * 
     * @type {number}
     * @memberof SplitByAmountSuccessResponse
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof SplitByAmountSuccessResponse
     */
    requestId?: string;
}

/**
 * Check if a given object implements the SplitByAmountSuccessResponse interface.
 */
export function instanceOfSplitByAmountSuccessResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentState" in value;
    isInstance = isInstance && "paymentReference" in value;
    isInstance = isInstance && "bookingReference" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function SplitByAmountSuccessResponseFromJSON(json: any): SplitByAmountSuccessResponse {
    return SplitByAmountSuccessResponseFromJSONTyped(json, false);
}

export function SplitByAmountSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SplitByAmountSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentReference': json['paymentReference'],
        'bookingReference': json['bookingReference'],
        'amount': json['amount'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
    };
}

export function SplitByAmountSuccessResponseToJSON(value?: SplitByAmountSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentState': PaymentStateToJSON(value.paymentState),
        'paymentReference': value.paymentReference,
        'bookingReference': value.bookingReference,
        'amount': value.amount,
        'requestId': value.requestId,
    };
}

